import { Injectable } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

// import { retry, catchError } from 'rxjs/operators';
// import { throwError } from 'rxjs';
import { Subject, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { ListaGeocerca } from 'src/app/models/mapa-geocerca';

@Injectable({
  providedIn: 'root'
})
export class ControlGeocercaService {

  public firstFiltroForm;
  private filtroForm = new Subject<any>();
  private geocercasObs = new Subject<any>();
  private geocercas = new Subject<any>();

  qs = require('qs');

  constructor(
    private gtp: Gtp,
    private http: HttpClient
  ) { }

  getFiltroForm(){
    return this.filtroForm.asObservable();
  }

  setFiltroForm(filtro){
    this.filtroForm.next(filtro);
  }

  callGeocercas() {
    this.getListaGeocercas().subscribe(res => {
      let lista = [];
      Object.entries(res['rows']).forEach(item => { lista.push( new ListaGeocerca(item[1]) ); });
      lista.sort(this.gtp.orderGeocercas);
      this.setGeocerca(lista);
    });
  }

  getGeocercas() {
    return this.geocercasObs.asObservable();
  }

  setGeocerca(geo) {
    this.geocercas.next(geo);
    this.geocercasObs.next(geo);
  }

  /**
   * Devuelve el listado de geocercas del usuario / cliente
   */
  getListaGeocercas(){
    var filter = {
      order: "nombre",
    }
    let urlFilter = this.qs.stringify(filter);
    return this.http.get(`${environment.baseUrl}clientes/geocercas/?`+urlFilter);
  }

  getControlGeocercaMoviles(filtro){
    //console.log(filtro)
    var filter = {
      order: "nombre",
      limit: filtro.pageSize,
      offset: filtro.pageIndex,
      historial: {
        fecha_hora: {
          between: [filtro.desde, filtro.hasta]
        },
        velocidad: {
          gte: 10
        }
        //limit: (filtro.historialSize) ? filtro.historialSize : 0
      }
    };

    let codGeocerca = '';
    if (filtro.geocerca) {
      codGeocerca = filtro.geocerca;
    }

    if(filtro.buscar){
      filter['equipoRastreo'] = {
        des_equipo_ratreo: {
          "iLike": `%${filtro.buscar}%`
        },
      };
    }
    // console.log(filter);
    // Cambio a POST con timeout extendido (60 segundos)
    return this.http.post(`${environment.baseUrl}clientes/historial-geocercas/${codGeocerca}`, filter)
      .pipe(
        timeout(60000), // 60 segundos de timeout
        catchError(error => {
          console.error('Error en getControlGeocercaMoviles:', error);
          return throwError(error);
        })
      );
  }

  orderFilter(order){
    let orderCol = '';
    switch(order){
      case 'fecha':
      case 'hora':
        orderCol = 'fecha_hora';
        break;
      case 'geocerca':
        orderCol = 'cod_evento';
        break;
      default:
        orderCol = order;
    }
    return orderCol;
  }

  getControlGeocercaMovil(codvehiculo, filtro){
    filtro.orderby = this.orderFilter(filtro.orderby);
    let orden = (filtro.sortby=="asc") ? "-"+filtro.orderby : filtro.orderby;
    var filter = {
      order: orden,
      fecha_hora: {
        between:  [filtro.desde,filtro.hasta]
      },
      limit: filtro.pageSize,
      offset: filtro.pageIndex
    };

    if (filtro.geocerca) {
      filter['gid'] = {
        in: filtro.geocerca
      }
    }

    // Cambio a POST con timeout extendido (60 segundos)
    return this.http.post(`${environment.baseUrl}clientes/${codvehiculo}/historial-geocercas/`, filter)
      .pipe(
        timeout(60000), // 60 segundos de timeout
        catchError(error => {
          console.error('Error en getControlGeocercaMovil:', error);
          return throwError(error);
        })
      );
  }

}
